import React, { Component } from 'react';

const initData = {
    preHeading: "Key",
    preHeadingspan: "Features",
    heading: "Smarter Sales Starts with SalesPinch",
    headingText: "Streamline lead workflows, empower your sales teams with mobile-first tools, and make data-driven decisions with built-in AI analytics.",
    headingTexttwo: "Lead smarter, close faster, grow consistently — with SalesPinch."
  };
  

  const data = [
    {
      image: "/img/featured_image_1.png",
      title: "Lead Funnel Automation",
      content: "Seamlessly assign leads from Tele Caller to Lead Manager to Lead Owner with clear departmental routing and custom rules."
    },
    {
      image: "/img/featured_image_2.png",
      title: "AI-Enhanced Follow-ups",
      content: "Let AI suggest next steps, identify leads at risk, and generate personalized follow-up messages to boost conversions."
    },
    {
      image: "/img/featured_image_3.png",
      title: "Mobile-First Lead Engagement",
      content: "Empower Lead Owners with Android and iOS apps to update lead status, log follow-ups, and get real-time notifications on the go."
    },
    {
      image: "/img/featured_image_4.png",
      title: "Performance Dashboards",
      content: "Visualize lead pipeline, conversion rates, department activity, and monthly comparisons — tailored to each role."
    },
    {
      image: "/img/featured_image_5.png",
      title: "Role-Based Access for Team Members",
      content: "Every team member has the right view — from Tele Callers entering leads to Managers analyzing reports to Monitors auditing progress."
    },
    {
      image: "/img/featured_image_6.png",
      title: "Smart Lead Suggestions",
      content: "Leverage AI suggestions to prioritize leads, draft emails, or identify missed opportunities based on engagement history and more."
    }
  ];
  
  

class FeatureSection extends Component {
    state = {
        initData: {},
        data: []
    }
    componentDidMount(){
        this.setState({
            initData: initData,
            data: data
        })
    }
    render() {
        return (
            <section id="features" className="section features-area style-two overflow-hidden ptb_100">
                <div className="container">
                    <div className="row">
                    <div className="col-12 col-md-10 col-lg-6">
                        {/* Section Heading */}
                        <div className="section-heading">
                        <span className="d-inline-block rounded-pill shadow-sm fw-5 px-4 py-2 mb-3">
                            <i className="far fa-lightbulb text-primary mr-1" />
                            <span className="text-primary">{this.state.initData.preHeading}</span>
                            {this.state.initData.preHeadingspan}
                        </span>
                        <h2>{this.state.initData.heading}</h2>
                        <p className="d-none d-sm-block mt-4">{this.state.initData.headingText}</p>
                        <p className="d-block d-sm-none mt-4">{this.state.initData.headingTexttwo}</p>
                        </div>
                    </div>
                    </div>
                    <div className="row">
                        {this.state.data.map((item, idx) => {
                            return(
                                <div key={`ffd_${idx}`} className="col-12 col-md-6 col-lg-4 my-3 res-margin">
                                    {/* Image Box */}
                                    <div className="image-box text-center icon-1 p-5">
                                    {/* Featured Image */}
                                    <div className="featured-img mb-3">
                                        <img className="avatar-sm" src={item.image} alt="" />
                                    </div>
                                    {/* Icon Text */}
                                    <div className="icon-text">
                                        <h3 className="mb-2">{item.title}</h3>
                                        <p>{item.content}</p>
                                    </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        );
    }
}

export default FeatureSection;